import React from "react";
import {
  CalendarIcon,
  AcademicCapIcon,
  LanguageIcon,
  MapPinIcon,
  EnvelopeIcon,
  PhoneIcon,
} from "@heroicons/react/24/outline";

const AboutSection = ({ school }) => {
  return (
    <section className="py-14 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="mb-10 text-center">
          <h2 className="text-3xl md:text-4xl font-extrabold text-indigo-700 tracking-tight">
            About {school?.name}
          </h2>
          <p className="mt-3 text-lg text-gray-600 max-w-3xl mx-auto">
            {school?.description}
          </p>
        </div>

        {/* Info Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <InfoCard
            label="Established"
            value={school?.establishedYear || "N/A"}
            Icon={CalendarIcon}
          />
          <InfoCard
            label="Board"
            value={school?.boardAffiliation || "N/A"}
            Icon={AcademicCapIcon}
          />
          <InfoCard
            label="Medium"
            value={school?.medium || "N/A"}
            Icon={LanguageIcon}
          />
          <InfoCard
            label="Location"
            value={
              school?.fullAddress && school?.city && school?.state
                ? `${school.fullAddress}, ${school.city}, ${school.state}`
                : "N/A"
            }
            Icon={MapPinIcon}
          />
          <InfoCard
            label="Email"
            value={school?.contactEmail || "N/A"}
            Icon={EnvelopeIcon}
          />
          <InfoCard
            label="Phone"
            value={school?.phone || "N/A"}
            Icon={PhoneIcon}
          />
        </div>
      </div>
    </section>
  );
};

// ✅ Reusable InfoCard component
const InfoCard = ({ label, value, Icon }) => (
  <div className="flex items-start space-x-4 bg-white/80 backdrop-blur-sm border border-gray-200 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 ease-in-out transform hover:-translate-y-1 hover:border-indigo-400 hover:ring-2 hover:ring-indigo-100 p-5">
    <Icon className="h-6 w-6 text-indigo-600 mt-1 shrink-0" />
    <div>
      <h4 className="text-sm text-gray-500 font-medium mb-1">{label}</h4>
      <p className="text-lg font-semibold text-gray-800 break-words">{value}</p>
    </div>
  </div>
);

export default AboutSection;
